//==================== INITIALIZED REDUX STORE STATE ======================

const INITIAL_STATE = {
    users: [],
    current_user: { isAuth: false, isLoading: true },
}

//=================== perform actions accordingly ============================

const store = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "currentUser":
            return ({
                ...state,
                current_user: action.payload
            })
        case "setAllUsers":
            return ({
                ...state,
                users: action.payload
            })
        default:
            return state;
    }
}

export default store;